import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function InventorySyncBar({ lastSync, onSync }) {
  const [syncing, setSyncing] = useState(false);

  const handleSync = () => {
    setSyncing(true);
    setTimeout(() => {
      setSyncing(false);
      onSync();
    }, 2000);
  };

  return (
    <div className="flex items-center gap-3 px-4 md:px-6 py-2 bg-muted border-b border-border">
      <div className={`w-2 h-2 rounded-full flex-shrink-0 ${syncing ? "bg-warning animate-pulse" : "bg-success"}`} />
      <span className="font-caption text-xs text-muted-foreground flex-1">
        {syncing ? "Syncing inventory..." : `Inventory synced: ${lastSync}`}
      </span>
      <div className="flex items-center gap-2">
        <span className="font-caption text-xs text-muted-foreground hidden sm:inline">
          <Icon name="Wifi" size={12} color="var(--color-success)" strokeWidth={2} className="inline mr-1" />
          Online
        </span>
        <Button variant="ghost" size="xs" iconName="RefreshCw" iconPosition="left" iconSize={12} onClick={handleSync} loading={syncing}>
          {syncing ? "Syncing" : "Sync Now"}
        </Button>
      </div>
    </div>
  );
}